module.exports = __webpack_public_path__ + "img/12_98.82e407e5.png";